export class Status {
  public static CLASSES: any = {
    success: "2xx",
    redirection: "3xx",
    clientError: "4xx",
    serverError: "5xx",
  };
}
